import { Reveal } from "./Reveal";
import { ArrowRight } from "lucide-react";

// Signature recurring motif: Audience member -> Participant -> Contributor -> Steward
export const Pathway = ({ items, active, compact = false }) => {
  return (
    <div
      data-testid="pathway-diagram"
      className="grid gap-3 md:grid-cols-4 md:gap-0"
    >
      {items.map((stage, i) => (
        <Reveal
          key={i}
          active={active}
          delay={0.15 + i * 0.16}
          className="relative"
        >
          <div className="relative h-full border border-ink bg-surface p-5 md:p-6">
            {/* stage index + fill bar */}
            <div className="flex items-center justify-between">
              <span className="mono text-xs text-stone">STAGE {String(i + 1).padStart(2, "0")}</span>
              <span
                className="h-3 w-3"
                style={{ background: i === items.length - 1 ? "#FFCC00" : "#111" }}
              />
            </div>
            {/* progress fill representing deepening relationship */}
            <div className="mt-3 h-1 w-full bg-line">
              <div
                className="h-full bg-canary"
                style={{ width: `${((i + 1) / items.length) * 100}%` }}
              />
            </div>
            <h3 className={`font-display mt-4 tracking-tight ${compact ? "text-xl" : "text-2xl md:text-[1.7rem]"} leading-tight`}>
              {stage.title}
            </h3>
            {!compact && (
              <p className="mt-2 text-sm leading-relaxed text-stone">{stage.desc}</p>
            )}
          </div>

          {/* connector arrow between stages (desktop) */}
          {i < items.length - 1 && (
            <div className="absolute right-0 top-1/2 z-10 hidden -translate-y-1/2 translate-x-1/2 md:block">
              <div className="flex h-7 w-7 items-center justify-center bg-ink">
                <ArrowRight className="h-4 w-4 text-canary" />
              </div>
            </div>
          )}
        </Reveal>
      ))}
    </div>
  );
};
